import React, { useState, useEffect, useRef } from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import Slide from '@material-ui/core/Slide'
import ReactToPrint from "react-to-print"
import { config } from '../../config'
import { MdPrint } from 'react-icons/md'
import { AiOutlineLoading } from "react-icons/ai"
import { memberService } from '../../_services/member.service'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
})


const LicensePrint = props => {
  const [loading, setLoading] = useState(false)
  const [showDialog, setShowDialog] = useState(false)
  const [data, setData] = useState(props.data)

  const printImage = useRef();

  useEffect(() => {

    setShowDialog(props.show)

    getData()

  }, [props.show, props.data])

  const getData = () => {



    // memberService.printLicence(props.data.id, props.data.trackId)
    //   .then((res) => {
    //     console.log(res.data)
    //     var data = res.data;
    //     setData(data)
    //   })
    //   .catch((error) => {
    //     setData(undefined)
    //   });
  };

  const handleCloseDialog = () => {

    setShowDialog(false)

    props.onClose()

  }

  const handlePrint = () => {

    setLoading(false)

    props.onClose()

  }

  return (
    <React.Fragment>
      <Dialog
        maxWidth="md"
        className="message-dialog"
        open={showDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => handleCloseDialog()}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent className="inquiry-result-container">

          <ReactToPrint
            onAfterPrint={() => handlePrint()}
            trigger={() => <div style={{ width: '100%', textAlign: 'center' }}><a className="btn btn-block btn-primary" onClick={() => setLoading(true)}>
              {loading ?
                <AiOutlineLoading className="mdi-spin" size="32px" style={{ marginLeft: 10 }} />
                :
                <MdPrint size="32px" style={{ verticalAlign: 'middle', marginLeft: 10 }} />
              }
              چاپ</a></div>}
            content={() => printImage.current}
          />
          <img ref={printImage} src={config.apiBaseUrl + 'Print/license/' + props.data.id} style={{ width: '100%', pageBreakAfter: 'avoid', pageBreakInside: 'avoid', marginBottom: 0 }} />
        </DialogContent>

      </Dialog>

    </React.Fragment>
  )
}

export default LicensePrint;